var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"12","fill":"none","viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m5 2 4 4-4 4M9 6H8","stroke":"#fff","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }